import { useState } from "react";
import { Link } from "react-router-dom";
import { WhatsappLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SECTORS, waLink } from "@/lib/site";
import { Logo } from "@/components/Logo";

export const ContactForm = ({ compact = false }) => {
  const [form, setForm] = useState({ name: "", company: "", sector: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Lütfen ad ve telefon alanlarını doldurun.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", form);
      setSent(true);
      toast.success("Mesajınız alındı, en kısa sürede dönüş yapacağız.");
      setForm({ name: "", company: "", sector: "", phone: "", message: "" });
    } catch {
      toast.error("Gönderilemedi, lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-border bg-background px-3.5 py-2.5 text-sm outline-none focus:border-brand transition-colors";

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="contact-form">
      <div className={compact ? "grid grid-cols-1 gap-3" : "grid sm:grid-cols-2 gap-3"}>
        <input data-testid="contact-name" placeholder="İsim *" value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        <input data-testid="contact-company" placeholder="Şirket" value={form.company}
          onChange={(e) => setForm({ ...form, company: e.target.value })} className={inputCls} />
        <select data-testid="contact-sector" value={form.sector}
          onChange={(e) => setForm({ ...form, sector: e.target.value })} className={inputCls}>
          <option value="">Sektör seçin</option>
          {SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <input data-testid="contact-phone" placeholder="Telefon *" value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })} className={inputCls} />
      </div>
      <textarea data-testid="contact-message" placeholder="Mesajınız" rows={compact ? 2 : 3} value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })} className={inputCls} />
      <button type="submit" disabled={loading || sent} data-testid="contact-form-submit"
        className="w-full bg-brand text-white font-medium py-3 disabled:opacity-60 hover:-translate-y-0.5 transition-transform">
        {sent ? "Gönderildi ✓" : loading ? "Gönderiliyor…" : "Gönder"}
      </button>
    </form>
  );
};

export const PublicFooter = () => (
  <footer className="border-t border-border bg-muted" id="iletisim">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12">
      <div>
        <Logo />
        <p className="text-muted-foreground mt-5 max-w-md leading-relaxed">
          Yapay zekâ asistanları müşteri kararlarını yönlendiriyor. AI Marka Radar,
          markanızın bu cevaplarda ne kadar göründüğünü ölçer ve görünürlüğünüzü artırır.
        </p>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
          className="inline-flex items-center gap-2 mt-6 bg-[#25D366] text-white font-medium px-5 py-3 hover:-translate-y-0.5 transition-transform">
          <WhatsappLogo size={20} weight="fill" /> WhatsApp'tan Yazın
        </a>
        <div className="flex flex-wrap gap-x-6 gap-y-2 mt-8 text-sm">
          <Link to="/hakkimizda" className="text-muted-foreground hover:text-brand">Hakkımızda</Link>
          <Link to="/iletisim" className="text-muted-foreground hover:text-brand">İletişim</Link>
          <Link to="/gizlilik" className="text-muted-foreground hover:text-brand">Gizlilik Politikası</Link>
          <Link to="/kvkk" className="text-muted-foreground hover:text-brand">KVKK Aydınlatma Metni</Link>
          <Link to="/blog" className="text-muted-foreground hover:text-brand">Blog</Link>
        </div>
      </div>
      <div className="border border-border bg-background p-6">
        <h3 className="font-heading font-semibold text-lg mb-1">Bize ulaşın</h3>
        <p className="text-sm text-muted-foreground mb-4">Formu doldurun, ekibimiz sizi arasın.</p>
        <ContactForm />
      </div>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground font-mono">
        <span>© 2026 AI Marka Radar</span>
        <span>Türkiye · AEO / GEO Marka Radar Platformu</span>
      </div>
    </div>
  </footer>
);
